// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import { store } from './store/store'
require('bootstrap-nucleus')

// NOTE: promise polyfill required for Vuex use in IE
require('es6-promise/auto')

require('./assets/main.scss')

Vue.config.productionTip = false

Vue.use(VueResource)

router.beforeEach((to, from, next) => {
  document.title = to.meta.title(to)
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  store
})



// WEBPACK FOOTER //
// ./src/main.js